module.exports = "<!--<div class=\"wrapper\">\r\n  <main-header></main-header>\r\n\r\n  <app-nav-menu></app-nav-menu>\r\n\r\n  <div class=\"content-wrapper\">\r\n    <section class=\"content-header\">\r\n      <h1>\r\n        Header\r\n      </h1>\r\n    </section>\r\n    <section class=\"content\"><router-outlet></router-outlet></section>\r\n  </div>\r\n\r\n  <main-footer></main-footer>\r\n\r\n</div>-->\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main